import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useParams, useLocation } from "react-router-dom";
import ClientOrderList from "./ClientOrderList";
import GeneralPlanningList from "./GeneralPlanningList/GeneralPlanningList";
import DisputeList from "../Dispute/DisputeList";
import UserInfo from "@utils/UserInfo";
import NotFound from "@components/Errors/NotFound";

/**
 * site GeneralInfo,
 * Path - /site/view/{id}
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3320578053/Plannings)
 * @component
 */
const Planning = (props) => {
  const { t } = props;
  const params = useParams();
  const validPaths = ["orders", "global", "daily", "disputes"];
  const location = useLocation();
  const basePath = location.pathname.split("/").slice(0, 2).join("/") + "/";
  
  if (
    basePath === "/planning/" &&
    !validPaths.includes(params.path)
  ) {
    return <NotFound />;
  }

  return (
    <>
      {params.path === "orders" && <ClientOrderList />}
      {params.path === "global" && <GeneralPlanningList page={params.path} />}
      {params.path === "daily" && <GeneralPlanningList page={params.path} />}
      {params.path === "suppliers" && (
        <GeneralPlanningList page={params.path} />
      )}
      {params.path === "disputes" && (
        <DisputeList page="main" platformCountryId={UserInfo.countryId()} />
      )}
    </>
  );
};
Planning.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Planning);
